<template>
    <div>
        <section>
            <div v-if="!validateResetTokenPending" class="container">
                <div class="row justify-center">
                    <div class="col-xs-12 col-sm-6 col-md-4" v-show="!isNewPasswordSet">
                        <div class="text-title">Reset Password</div>
                        <q-banner v-if="showError" rounded class="text-white bg-negative">
                            <q-icon name="mdi-alert" size="sm" color="white" class="q-mr-xs" />
                            {{ errorMessage }}
                        </q-banner>
                        <q-form @submit="onSubmit"
                                autocomplete="off"
                                class="q-gutter-md q-my-md">
                            <q-input outlined dense
                                     :type="isPwd ? 'password' : 'text'"
                                     label="New Password" stack-label
                                     autocomplete="new-password" name="password"
                                     v-model="password"
                                     :rules="[ val => $v.password.required || 'Password is required', val => $v.password.minLength || `Password must have at least ${$v.password.$params.minLength.min} letters`]"
                                     hide-bottom-space>
                                <template v-slot:append>
                                    <q-icon :name="isPwd ? 'mdi-eye-off' : 'mdi-eye'"
                                            class="cursor-pointer"
                                            color="grey-6" size="0.9em"
                                            @click="isPwd = !isPwd" />
                                </template>
                            </q-input>

                            <q-input outlined dense
                                     :type="isPwdConfirm ? 'password' : 'text'"
                                     label="Confirm Password" stack-label
                                     autocomplete="new-password" name="confirmPassword"
                                     v-model="confirmPassword"
                                     :rules="[ val => $v.confirmPassword.sameAsPassword || 'Confirmation password does not match' ]"
                                     hide-bottom-space>
                                <template v-slot:append>
                                    <q-icon :name="isPwdConfirm ? 'mdi-eye-off' : 'mdi-eye'"
                                            class="cursor-pointer"
                                            color="grey-6" size="0.9em"
                                            @click="isPwdConfirm = !isPwdConfirm" />
                                </template>
                            </q-input>

                            <div class="row">
                                <q-btn :label="resetPasswordPending ? 'Changing...' : 'Reset Password'" type="submit" color="primary" class="col-xs-12 col-sm-auto" />
                            </div>

                            <q-inner-loading :showing="resetPasswordPending">
                                <div>
                                    <q-spinner color="primary"
                                               :thickness="2"
                                               size="3em" />
                                </div>
                            </q-inner-loading>
                        </q-form>
                    </div>
                    <div class="col-auto" v-show="isNewPasswordSet">
                        <div class="text-title">Password has been successfully reset!</div>
                        <div class="row q-col-gutter-sm q-mt-sm">
                            <p>You can now log in with your new password.</p>
                        </div>
                        <div class="row q-mt-sm">
                            <q-btn label="Return To Login" color="primary" class="col-xs-12 col-sm-auto" @click="returnToLogin" />
                        </div>
                    </div>
                </div>
            </div>

            <q-inner-loading :showing="validateResetTokenPending">
                <div>
                    <q-spinner color="primary"
                               :thickness="2"
                               size="3em" />
                </div>
            </q-inner-loading>
        </section>
    </div>
</template>
<script>
    import { required, minLength, sameAs } from 'vuelidate/lib/validators'
    import { mapState } from 'vuex'

    export default {
        name: 'reset-pass',
        data() {
            return {
                userId: '',
                token: '',
                returnUrl: '',
                showError: false,
                errorMessage: '',
                isPwd: true,
                isPwdConfirm: true,
                password: '',
                confirmPassword: '',
                isNewPasswordSet: false,
            }
        },
        validations: {
            password: {
                required,
                minLength: minLength(8)
            },
            confirmPassword: {
                sameAsPassword: sameAs('password')
            }
        },
        methods: {
            validateToken() {
                const payload = { userId: this.userId, token: this.token }
                this.$store.dispatch('validateResetToken', payload).then(() => {
                    if (!this.validateResetTokenData) this.$router.push('/forgotpass?expired=true').catch(err => { })
                }).catch(err => {
                    this.$router.push('/forgotpass?expired=true').catch(err => { })
                })
            },
            resetPass() {
                const payload = { id: this.userId, token: this.token, newPassword: this.password, confirmPassword: this.confirmPassword }
                this.$store.dispatch('resetPassword', payload).then(() => {
                    this.$store.dispatch('getEmailById', this.userId).then(() => {
                        this.isNewPasswordSet = true;
                    })
                }).catch(err => {
                    this.errorMessage = err
                    this.showError = true
                })
            },
            onSubmit() {
                this.$v.$touch()
                if (this.$v.$pending || this.$v.$error) return
                this.resetPass()
            },
            returnToLogin() {
                if (this.returnUrl) {
                    this.$router.push({
                        path: this.returnUrl,
                        query: { login: true },
                    }).then(() => {
                        window.location.reload();
                    });
                }
                else {
                    this.$router.push({
                        path: '/',
                        query: { login: true },
                    }).then(() => {
                        window.location.reload();
                    });
                }
            },
        },
        computed: {
            ...mapState([
                'resetPasswordPending',
                'resetPasswordData',

                'validateResetTokenPending',
                'validateResetTokenData',
            ]),
        },
        created() {
            if (!this.$route.query.userId || !this.$route.query.token)
                this.$router.push('/').catch(err => { })

            this.userId = this.$route.query.userId
            this.token = encodeURIComponent(this.$route.query.token)
            this.returnUrl = this.$route.query.returnUrl
            this.validateToken()

        },
        watch: {
            '$route.query.userId'(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.userId = newVal
                }
            },
            '$route.query.token'(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.token = encodeURIComponent(newVal)
                }
            },
            '$route.query.returnUrl'(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.returnUrl = newVal
                }
            },
        },
    }
</script>
